export default __webpack_public_path__ + "static/media/SampleSecurityCode.1fc4de4f.svg";